import { Component, OnInit, HostListener, Output, EventEmitter, Input } from '@angular/core';
import { modal, alert, subTop } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { NotificacaoService } from '../services/notificacao.service';
import { ManutencaoService } from '../services/manutencao.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';


@Component({
	selector: 'app-top-bar',
	templateUrl: './top-bar.component.html',
	styleUrls: ['./top-bar.component.css'],
	animations: [modal, alert, subTop]
})
export class TopBarComponent implements OnInit {
	public usuario_perfil;
	public notificacoes = [];
	public mostraMenu = 'hidden';
	public modalLogout = 'hidden';
	public nomeUsuario = "";

	public menu_id = 168; //Notificações 
	//acesso
	public visualizar = true;
	public editar = false;

	@Output() public topBarEvent = new EventEmitter();
	@Output() public overlay = new EventEmitter();
	@Input() public sidebar;
	@Input() public barras;

	private dataAtual = moment().format('YYYY-MM-DD');

	@HostListener('document:click', ['$event'])
	documentClick(event: MouseEvent) {
		if (this.mostraMenu == 'shown')
			this.mostraMenu = 'hidden';
	}

	constructor(private authSvc: AuthService,
		private manutencaoSvc: ManutencaoService,
		private notificacaoSvc: NotificacaoService,
		private perfilUsuarioSvc: PerfilUsuarioService,
	) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();

		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].visualizar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  


		this.pegaNotificacoes();
		this.pegaNome();
	}

	pegaNome(){
		this.nomeUsuario = this.authSvc.getUser().usuario_login;
	}

	pegaNotificacoes() {
		this.notificacaoSvc.getNotificacoes(this.authSvc.getUsuarioId()).then((data: any) => {
			this.notificacoes = data;
			setTimeout(() => {
				this.pegaNotificacoes();
			}, 10000);
		}).catch((err) => {
			setTimeout(() => {
				this.pegaNotificacoes();
			}, 10000);
		});
	}

	abreMsgAlertas(e) {
		// precisa ser dps do evento de clique
		// meio feio, mas funciona por enqto
		setTimeout(() => {
			this.mostraMenu = 'shown';
		}, 10);
	}

	logout() {
		Swal.fire({
			type: 'question',
			title: 'Logout',
			text: 'Deseja realmente sair?',
			showCancelButton: true,
			cancelButtonColor: '#a6a6a6',
			confirmButtonColor: '#3085d6',
			cancelButtonText: 'Não',
			confirmButtonText: 'Sim',
			reverseButtons: true
		}).then((result) => {
			if (result.value) {
				this.authSvc.logout();
			}
		});
	}

	showSidebar() {
		if (this.sidebar == true) {
			this.topBarEvent.emit(false);
			this.overlay.emit(false);
			this.sidebar = false;
		}
		else {
			this.topBarEvent.emit(true);
			this.overlay.emit(true);
			this.sidebar = true;
		}
	}
}
